import IconButton, { IconButtonProps } from '@mui/material/IconButton';

export { IconButton };
export type { IconButtonProps };
export default IconButton;
